import { onMounted, onBeforeUnmount } from "vue";
const useRequestAnimationFrame = (cb) => {
  let animationFrameRequest = -1;
  const observe = () => {
    animationFrameRequest = requestAnimationFrame(observe);
    cb();
  };
  onMounted(() => {
    observe();
  });
  onBeforeUnmount(() => {
    cancelAnimationFrame(animationFrameRequest);
  });
};
export {
  useRequestAnimationFrame as u
};
//# sourceMappingURL=useRequestAnimationFrame-8c0a599c.mjs.map
